"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _DateRangePicker = _interopRequireDefault(require("../components/DateRangePicker"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../src/constants");
var _reactMomentProptypes = _interopRequireDefault(require("react-moment-proptypes"));
var _FocusedInputShape = _interopRequireDefault(require("../shapes/FocusedInputShape"));
var _ramda = require("ramda");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var propTypes = process.env.NODE_ENV !== "production" ? {
  // required props for a functional interactive DateRangePicker
  startDate: _reactMomentProptypes["default"].momentObj,
  endDate: _reactMomentProptypes["default"].momentObj,
  onDatesChange: _propTypes["default"].func.isRequired,
  focusedInput: _FocusedInputShape["default"],
  onFocusChange: _propTypes["default"].func.isRequired,
  //optional props for special styling
  numberOfPlaybookVersions: _propTypes["default"].number,
  isOutsideRange: _propTypes["default"].func,
  showQuickSelects: _propTypes["default"].bool,
  onQuickSelect: _propTypes["default"].func,
  disabledQuickSelectButtonList: _propTypes["default"].array,
  allowSingleDateSelection: _propTypes["default"].bool
} : {};
var defaultProps = {
  // input related props
  startDateId: _constants.START_DATE,
  endDateId: _constants.END_DATE,
  small: true,
  // calendar presentation and interaction related props
  anchorDirection: _constants.ANCHOR_RIGHT,
  numberOfMonths: 2,
  keepOpenOnDateSelect: true,
  hideKeyboardShortcutsPanel: true,
  disabledQuickSelectButtonList: [],
  allowSingleDateSelection: false
};
var DriftDatePicker = /*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DriftDatePicker, _React$Component);
  function DriftDatePicker() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = DriftDatePicker.prototype;
  _proto.render = function render() {
    var allowSingleDateSelection = this.props.allowSingleDateSelection;
    return _react["default"].createElement(_DateRangePicker["default"], _extends({
      minimumNights: allowSingleDateSelection ? 0 : 1
    }, (0, _ramda.omit)(['allowSingleDateSelection'], this.props)));
  };
  return DriftDatePicker;
}(_react["default"].Component);
DriftDatePicker.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DriftDatePicker.defaultProps = defaultProps;
var _default = DriftDatePicker;
exports["default"] = _default;